import { Component, OnDestroy, OnInit } from "@angular/core";
import { RequestListType } from "app/bundles/requests/shared/enums/request-list-type.enum";
import { UtilService } from "app/bundles/requests/shared/services/util.service";
import { CoreService } from "app/core/core.service";
import { StorageService } from "app/shared/services/storage.service";
import { Observable, Subscription, of as observableOf } from "rxjs";

@Component({
  selector: "app-request-list-parent",
  templateUrl: "./request-list-parent.component.html",
  styleUrls: ["./request-list-parent.component.scss"],
})
export class RequestListParentComponent implements OnInit, OnDestroy {
  public requestCount = 0;
  private requestListType = RequestListType;
  private listType: number = RequestListType.BOTH;
  private subscriptions = new Subscription();
  public showMap: Observable<boolean> = observableOf(true);
  public showList: Observable<boolean> = observableOf(true);

  constructor(
    private coreService: CoreService,
    private storageService: StorageService,
    private utilsService: UtilService,
  ) {}

  ngOnInit() {
    if (this.storageService.getGeoJsonRequest()) {
      this.subscriptions.add(
        this.coreService.listType$.subscribe((listType: RequestListType) => {
          if (listType) {
            this.listType = listType;
            this.showMap = observableOf(
              this.listType === this.requestListType.BOTH ||
                this.listType === this.requestListType.MAP,
            );
            this.showList = observableOf(
              this.listType === this.requestListType.BOTH ||
                this.listType === this.requestListType.LIST,
            );
          }
        }),
      );
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getStyleMap(): any {
    if (this.listType === this.requestListType.BOTH) {
      return this.utilsService.getOrientation() === "PORTRAIT"
        ? { height: "50%" }
        : { height: "100%" };
    } else if (this.listType === this.requestListType.MAP) {
      return this.utilsService.getOrientation() === "PORTRAIT"
        ? { height: "100%" }
        : { height: "100%" };
    } else {
      return this.utilsService.getOrientation() === "PORTRAIT"
        ? { height: "0%" }
        : { height: "100%" };
    }
  }

  getStyleList(): any {
    if (this.listType === this.requestListType.BOTH) {
      return this.utilsService.getOrientation() === "PORTRAIT"
        ? { height: "50%" }
        : { height: "100%" };
    } else if (this.listType === this.requestListType.MAP) {
      return this.utilsService.getOrientation() === "PORTRAIT"
        ? { height: "0%" }
        : { height: "100%" };
    } else {
      return this.utilsService.getOrientation() === "PORTRAIT"
        ? { height: "100%" }
        : { height: "100%" };
    }
  }
}
